import React, { useState } from 'react';

const ManageBrandsModal = ({ isOpen, onClose, brands, onAddBrand, onDeleteBrand, inventory }) => {
    const [newBrandName, setNewBrandName] = useState('');

    if (!isOpen) return null;

    const handleAddBrand = async (e) => {
        e.preventDefault();
        if (newBrandName.trim()) {
            const isDuplicate = brands.some(b => b.name.toLowerCase() === newBrandName.trim().toLowerCase());
            if (isDuplicate) {
                alert(`A marca "${newBrandName}" já existe.`);
                return;
            }
            
            try {
                await onAddBrand(newBrandName.trim());
                setNewBrandName('');
            } catch (error) {
                console.error("Erro ao adicionar marca:", error);
                // Em uma aplicação real, mostrar uma notificação ao usuário
            }
        }
    };
    
    const handleDeleteBrand = async (brandId, brandName) => {
        const isBrandInUse = inventory.some(p => p.brand === brandName);
        if (isBrandInUse) {
            alert(`Não é possível apagar a marca "${brandName}", pois ela está sendo usada em um ou mais produtos.`);
            return;
        }

        try {
            await onDeleteBrand(brandId);
        } catch (error) {
            console.error("Erro ao deletar marca:", error);
            // Em uma aplicação real, mostrar uma notificação ao usuário
        }
    };


    return (
        <div className="modal-overlay">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-md m-4 sm:m-8 max-h-[90vh] flex flex-col">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">Gerenciar Marcas</h2>
                
                <form onSubmit={handleAddBrand} className="flex flex-col sm:flex-row gap-2 mb-4">
                    <input 
                        value={newBrandName} 
                        onChange={(e) => setNewBrandName(e.target.value)} 
                        type="text" 
                        placeholder="Nome da nova marca" 
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
                        required 
                    />
                    <button 
                        type="submit" 
                        className="custom-button py-2 px-4 font-semibold rounded-lg w-full sm:w-auto flex-shrink-0"
                    >
                        Adicionar
                    </button>
                </form>

                <div className="flex-grow overflow-y-auto border-t border-b border-gray-200 -mx-6 sm:-mx-8 px-6 sm:px-8 py-2">
                    <ul className="space-y-2">
                        {brands.map(brand => (
                            <li key={brand.id} className="flex justify-between items-center p-2 hover:bg-gray-50 rounded-md">
                                <span className="text-gray-800">{brand.name}</span>
                                <button 
                                    className="action-btn delete-btn text-lg" 
                                    onClick={() => handleDeleteBrand(brand.id, brand.name)}
                                    title={`Excluir marca ${brand.name}`}
                                >
                                    🗑️
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                
                <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-6 mt-auto">
                    <button 
                        type="button" 
                        onClick={onClose} 
                        className="py-2 px-6 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 w-full sm:w-auto"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ManageBrandsModal;
